import base from './spec/base';

export default {
  base,
  isLoading: false,
  loginUser: {},

  companies: {},
  positions: {},
  groups: {},
  teams: {},
  categories: {},
  // jobs: {},
  services: {},
  members: [],
  membersWithAuthority: [],
  logOfMemberWithAuthority: [],
  selectedMember: null,

  message: {
    toast: {},
    alert: {},
    confirm: {},
    notification: {},
  },
};



// WEBPACK FOOTER //
// ./src/store/state.js